export default "__VITE_ASSET__4534efcd__"